// extracted by mini-css-extract-plugin
export default {"header":"ViewBooked_header__pkrH8","viewBooked":"ViewBooked_viewBooked__dhZyk"};